/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxWpm: NonNullable<unknown> }} Error_Nav_Wpm_ExceedsInputs */



/**
* | output |
* | --- |
* | "WPM exceeds maximum set rate ({maxWpm})." |
*
* @param {Error_Nav_Wpm_ExceedsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_wpm_exceeds = /** @type {((inputs: Error_Nav_Wpm_ExceedsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Wpm_ExceedsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le WPM depasse le taux maximal defini (${i?.maxWpm}).`)
	if (locale === "de") return /** @type {LocalizedString} */ (`WPM überschreitet die maximal eingestellte Rate (${i?.maxWpm}).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il WPM supera la velocità massima impostata (${i?.maxWpm}).`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Скорость печати в словах превышает максимально установленную скорость (${i?.maxWpm}).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`WPM excede la velocidad máxima establecida (${i?.maxWpm}).`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`WPM 超过最大设定速率 (${i?.maxWpm})。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`WPM が最大設定速度 (${i?.maxWpm}) を超えています。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`WPM अधिकतम निर्धारित दर (${i?.maxWpm}) से अधिक है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`WPM excede a taxa máxima definida (${i?.maxWpm}).`)
	return /** @type {LocalizedString} */ (`WPM exceeds maximum set rate (${i?.maxWpm}).`)
});